import SecureLinkUtility from '@sparta.global.utilities/secure-link-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaSqueezeboxUtility from '@sparta.global.utilities/sparta-squeezebox-utility/dist/es6.js';
import { squeezebox } from '@sparta.global.helpers/squeezebox-helper/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row\">\n  <div class=\"small-12 column\">\n    "
    + container.escapeExpression((lookupProperty(helpers,"squeezebox")||(depth0 && lookupProperty(depth0,"squeezebox"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"partials") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"squeezebox") : stack1),{"name":"squeezebox","hash":{},"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":3,"column":46}}}))
    + "\n  </div>\n</div>";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.sb-credit-cards.modules/faq-sbcc-module",
  "version": "1.0.1",
  "id": "faqSbccModule",
  "containerID": "sbCreditCardsFaqSbccModule",
  "moduleName": "sb-credit-cards-faq-sbcc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "faq-sbcc-module",
  "data": {
    "init": "faqSbccModule",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        squeezebox
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    squeezebox
  },
  "dependencies": {
    "@sparta.global.utilities/secure-link-utility": "^1.0.0",
    "@sparta.global.helpers/squeezebox-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-squeezebox-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0"
  },
  "stores": []
};

/**
 * The faqSbccModule Sparta Module.
 * sparta generate module
 * @export
 * @class
 */
/**
 *
 *
 * @export
 * @class faqSbccModule
 * @extends {Module}
 */
class faqSbccModule extends Module {
  /**
   * Creates an instance of faqSbccModule.
   * @param {object} options module options
   * @param {object} context module context
   * @memberof faqSbccModule
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * Called when this module is bootstrapped by the client.
   * @param {object} options The options this module was initialized with.
   * @returns {undefined}
   */
  init() {
    spartaSqueezeboxUtility.init();
    SecureLinkUtility.run();
  }
}
registerModuleClass({
  moduleClass: faqSbccModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { faqSbccModule as default, moduleConfig };
